import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryCreator } from '@utils/baseQueryCreator';

import { ENV } from '@constants';

export const apiSlice = createApi({
  reducerPath: 'api',
  endpoints: () => ({}),
  refetchOnReconnect: true,
  baseQuery: (...arguments_) =>
    baseQueryCreator(ENV.VITE_BONUS_API_URL)(...arguments_),
});
